import React from "react";

const ResponsibleGamePlay = () => {
    return(<section className="privacypage">
        <div className="main-header">
            <div className="container pravcypolicycontainer">
                <div className="row">
                    <div className="col-md-12">
                        <h1>Responsible Game Play</h1>
                    </div>
                </div>
            </div>
        </div>
        <div className="comnpages">
            <div className="container pravcypolicycontainer">
                <div className="row">
                <div className="col-md-12">
                        <p>
                        At  Sweepstakes  Central,  our  goal  is  to  provide  you  access  to  a  fun  entertainment  experience 
                        through responsible social game play.  They key word is “responsible.”  We understand there are 
                        inherent  risks  associated  with  online  game  play  which  can  be  detrimental  both  socially  and 
                        financially if our customers do not exercise appropriate discretion.  To that end, we have created 
                        control measures, which are available to you whenever you feel you might be spending too much 
                        time playing social games.  We also reserve the right to implement these control measures if we, 
                        in our independent judgment, believe you are playing irresponsibly.
                        <br /><br />
                        <strong>Helpful Tips</strong>
                        </p>
                        <p>
                            Set  a  Budget  –  Only  purchase  play  credits  if  you  can  afford  it.    Remember,  we  have  free  entry options that you can use whenever you want.  Free play is always available to our customers.
                            <br /><br />
                            Track your Time – Online social game play is a great form of entertainment, but it should not be 
                            used as an escape from reality.  Too much screen time is not healthy for anyone.  We want you 
                            to play for an appropriate amount of time, take breaks when needed, and then come back later.  
                            Our  goal  is  not  for  our  customers  to  spend  endless  hours  in  front  of  their  computer  screen  or 
                            mobile device.
                            <br /><br />
                            Self-Assess – If you believe you or a friend/family member is engaging in problem-gaming, you 
                            should strongly consider self-assessing.  Here are some common indicators that you or another 
                            might have a problem:
                            <br /><br />
                            <ul>
                                <li>You hide your gaming from friends and/or a lie about how often you play and how much 
money you spend playing.</li>
                                <li>You binge-play, spending hours and hours on your computer or mobile device.</li>
                                <li>You use gaming to comfort yourself and/or escape from problems or difficulties in your 
career or personal life.</li>
                                <li>You play first thing in the morning or late into the night and lose sleep as a result of your 
gaming.</li>
                                <li>You skip work, school, or other responsibilities in order to spend more time gaming.</li>
                                <li>You feel guilty, shameful, or embarrassed about your gaming habits.</li>
                                <li>You experience extreme highs or lows in your emotions while gaming.</li>
                            </ul>
                        </p>
                        <p>
                           If, after performing a self-assessment, you feel you need additional support or help, you may want 
                            to consider contacting Computer Gaming Addicts Anonymous (CGAA).  This is an organization 
                            dedicated  to  helping  those  who  are  addicted  to  computer  games.    It  can  be  contacted  at 
                            <a href="mailto:helpline@cgaa.info" style={{ float: "none", width: "auto", margin: "0 5px 0" }} >helpline@cgaa.info</a>. Sweepstakes Central has no affiliation with CGAA whatsoever.  
                            Sweepstakes Central cannot attest for CGAA’s effectiveness in assisting with problem-gaming.  
                            CGAA  has  no  affiliation  with  Sweepstakes  Cerntral  and  cannot  provide  any  assistance  or 
                            customer support related to your account. 
                            <br/><br/>
                            Be Responsible When Gaming – It is never a good idea to play computer games as your primary 
                            source of income or to attempt to earn winnings to pay off debts.  Neither is it a good idea to play 
                            computer games while under the influence of alcohol or drugs.
                            <br/><br/>
                            Protect  Minors  –  If  you  have  minors  in  your  household  and/or  minors  who  have  access  the 
                            devices you use to play, you should take steps to protect them.  Be sure to protect your passwords 
                            and always log out when you are not in front of your gaming device.  There are numerous vendors 
                            and/or  services/settings  that  can  be  used  to  restrict  access  on  your  devices  and  ensure  any 
                            accessible content is age-appropriate, and we recommend utilizing such resources if they fit your 
                            household’s needs.
                        </p>
                        <p>
                            <strong>Sweepstakes Central Control Measures</strong>
                            <br /><br />
                            In order to assist you in gaming responsibly, we have created the following tools for you to use at 
                            your  discretion.    We  may  also,  at  our  sole  discretion,  utilize  any  of  these  tools  to  limit  your 
                            play/access if we feel you are engaging in irresponsible game play.
                            <br /><br />
                            Credit Limits – you can self-regulate the amount of purchase or obtain for free within any 24-hour 
period  by  setting  automatic  limits.    Once  you  hit  your  daily  limit,  we  will  not  provide  any  more 
credits.  Contact our customer support team if you want to set limits.
                            <br /><br />
                            Block Yourself – if you find that you are unable to exercise self-control altogether, you can request 
that  we  block  you  from  your  account  and/or  erase  your  account  and  save  your  name  to  our 
database of self-excluded customers.  This will result in us closing your account and preventing 
you from opening a new account with the same contact information.  If you ever want to re-open 
your account or open a new account with the same contact information, you will have to complete 
and sign a form swearing that you have obtained help for your problem-playing and that you are 
now able to exercise self-control.  This form can be obtained by contacting our customer support 
team.
<br/><br/>
Contact  our  customer  support  team  if  you  would  like  your  account  to  be  blocked.    Please  be 
aware, it may take some time for our customer support team to block access to your account.  
We will advise you once it has been blocked.  If you are able to access your account once we have 
told you it is blocked, please contact us immediately so that we can address whatever technical 
problem may have occurred. 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>)
}

export default ResponsibleGamePlay;